module.exports = __webpack_public_path__ + "img/georgia+helvetica.bbe8f595.png";